<template>
  <div>
    <p class="mb-5">{{ 'report-of-sickness.form.edit-description' | translate }}</p>

    <employee-card
      :employee="this.employee" showPolicies
      :policyCoverageDate="editReportOfSickness.firstOfAbsence"
      class='mt-5 mb-4' />

    <ReportOfSicknessForm :isEditing="true" :employee="this.employee" />

    <div style='float: right' class='mt-4'>
      <Button text="Annuleren" primary class='mr-3' @click="cancel">
        {{ 'buttons.cancel' | translate }}
      </Button>

      <Button secondary
        @click="navigate(views.Confirmation)"
        :disabled="!isValid"
        :hoverErrors="continueHoverErrors">
        {{ 'buttons.next-step' | translate }}
      </Button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';

import ReportOfSicknessForm from '@/views/components/reports-of-sickness/ReportOfSicknessForm.vue';
import EmployeeCard from '@/views/components/employees/EmployeeCard.vue';

import ERS from '@/views/constants/report-of-sickness-edit';
import ValidationCodes from '@/views/helpers/validation-codes';

export default {
  name: 'EditReportOfSickness',
  components: {
    Button,
    EmployeeCard,
    ReportOfSicknessForm
  },
  props: {
    reportOfSickness: Object
  },
  data () {
    return {
      views: ERS.Views
    };
  },

  computed: {
    ...mapGetters({
      requiredFields: 'editReportOfSicknessRequiredFields',
      validations: 'editReportOfSicknessValidations',
      editReportOfSickness: 'editReportOfSickness'
    }),

    employee () {
      return this.$store.getters.employees.find(employee => employee.id === this.reportOfSickness.employeeId);
    },

    isValid () {
      return this.requiredFields.isValid() && this.validations.isValid();
    },

    continueHoverErrors () {
      const requiredFieldsError =
        this.requiredFields.isValid() ? [] : [ this.$t('errors.provide-all-required-fields') ];

      const noChangesErrors = this.validations.errorsFor('reportOfSickness')
        .filter(e => e.code === ValidationCodes.NO_CHANGES)
        .map(e => this.$t(e.message));

      return _.union(requiredFieldsError, noChangesErrors);
    }
  },
  methods: {
    ...mapActions({
      navigate: ERS.Actions.Navigate.DO,
      cancel: ERS.Actions.Cancel.DO
    })
  }
};
</script>
